"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("./Paginations.css");

var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
    Pagination
    
	Renders a basic pagination. Returns the number you've clicked on,
	or the first, last, next, or previous page

    Verified by: Yorben Verhoest
    Date: 06/12/2019
    identityBuilding bvba
    https://identitybuilding.be
*/
// Our main component
var Pagination = function Pagination(_ref) {
  var getPage = _ref.getPage,
      pages = _ref.pages;
  var pagination = [],
      currentPage = pages.currentPage,
      lastPage = pages.totalPages;

  var _loop = function _loop(i) {
    if (currentPage !== 1) {
      // If we're not an page 1, show the "go to first page" arrow icon
      if (i === 0) // Only render arrow in the first loop
        pagination.push( /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
          key: "prevArrows"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "pageLeftArrow",
          onClick: function onClick() {
            return getPage(1);
          }
        }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
          name: "ArrowDoubleLeft"
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: "pageLeftArrow",
          onClick: function onClick() {
            return getPage(pages.prevPage);
          }
        }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
          name: "ArrowLeft"
        }))));
    }

    var setPage = void 0;
    if (currentPage === 1) setPage = currentPage + i;else if (currentPage === 2) setPage = currentPage - 1 + i;else if (currentPage === 3) setPage = currentPage - 2 + i;else if (currentPage > 3 && currentPage < lastPage - 1) setPage = currentPage - 2 + i;else if (currentPage === lastPage - 1) setPage = currentPage - 3 + i;else if (currentPage === lastPage) setPage = currentPage - 4 + i;

    if (setPage <= lastPage) {
      pagination.push( /*#__PURE__*/_react["default"].createElement("div", {
        className: currentPage === setPage ? 'active pageNumber' : 'pageNumber',
        key: setPage,
        onClick: function onClick() {
          return getPage(setPage);
        }
      }, setPage));
    }

    if (currentPage !== pages.totalPages) {
      // If we're not the last page, show the "go to last page" arrow icon
      if (i === 4) // Only render arrow in the last loop
        pagination.push( /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
          key: "nextArrows"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "pageRightArrow",
          onClick: function onClick() {
            return getPage(pages.nextPage);
          }
        }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
          name: "ArrowRight"
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: "pageRightArrow",
          onClick: function onClick() {
            return getPage(pages.totalPages);
          }
        }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
          name: "ArrowDoubleRight"
        }))));
    }
  };

  for (var i = 0; i < 5; i++) {
    _loop(i);
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "pagination"
  }, pagination);
};

var _default = Pagination;
exports["default"] = _default;